import { render, staticRenderFns } from "./WfConsumerCorpGroupForm.vue?vue&type=template&id=552d18d8&"
import script from "./WfConsumerCorpGroupForm.vue?vue&type=script&lang=js&"
export * from "./WfConsumerCorpGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports